var map = {
	"./1/image_big_logo.png": "8094",
	"./2/image_big_logo.png": "bcbc",
	"./3/image_big_logo.png": "660f",
	"./4/image_big_logo.png": "dd96",
	"./5/image_big_logo.png": "55e9",
	"./6/image_big_logo.png": "13f3",
	"./7/image_big_logo.png": "b4b7",
	"./8/image_big_logo.png": "d7fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c0fe";